module.exports = __webpack_public_path__ + "img/29.a4dd6c27.jpg";